import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { PlexEnvironment } from '@app/env';
import { IProject } from 'app/shared/interfaces';

@Injectable({ providedIn: 'root' })
export class ProjectHeaderService {
  private http = inject(HttpClient);
  public environment = inject(PlexEnvironment);

  private BASE_URL = this.environment.apiUrl;
  private tableName: string = 'Projects';

  public getProject(_fv: number): Promise<any> {
    let url = `${this.BASE_URL}${this.tableName}(${_fv})`;

    return this.http
      .get(url)
      .toPromise()
      .then(response => response);
  }

  public getProjectHeader(_fv: number, ent: any): Promise<any> {
    let url = `${this.BASE_URL}${this.tableName}(${_fv})` + ent;

    return this.http
      .get(url)
      .toPromise()
      .then(response => response);

  }

  public async update(_fv: number, project: IProject): Promise<IProject> {
    let url = `${this.BASE_URL}${this.tableName}(${_fv})`;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return await this.http
      .patch(url, project, { headers: headers })
      .toPromise()
      .then(response => response as IProject);
  }
}